import { createActionCreator } from '../../utils/helpers';

import { completeOnboarding } from './types';

export const onboardingComplete = createActionCreator(completeOnboarding.request, 'preference');
export const onboardingCompleteSuccess = createActionCreator(
  completeOnboarding.success,
  'response',
);
export const onboardingCompleteFailure = createActionCreator(completeOnboarding.failure, 'error');
